(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('BannersController', BannersController);

  /* ngInject */
  function BannersController(bannerService, sessionService) {
    const vm = this;

    vm.banners = [];
    vm.getBanners = getBanners;

    activate();

    function activate() {
      getBanners();
    }

    function getBanners() {
      bannerService(sessionService.getAuthToken()).query(_getBannersSuccess);
    }

    function _getBannersSuccess(response) {
      vm.banners = response;
    }
  }
})();
